import HeaderTitle from 'components/TableExtended/partials/HeaderTitle/HeaderTitle'

export default HeaderTitle
